<template>
  <div class="deviceList">
    <el-table
      stripe
      v-loading="loading"
      ref="multipleTable"
      :data="newTable"
      style="width: 100%"
      :show-header="false"
      :height="tableHeight"
      @select="handleSelectRow"
    >
      <el-table-column type="selection" width="19" align="left" />
      <el-table-column prop="name" show-overflow-tooltip>
        <template #default="{ row }">
          <div>
            <!-- 做判断 因为实时情况和数据分析共用这个组件-->
            <template v-if="routerType === 'real'">
              <i
                style="margin-right: 5px"
                :class="
                  equiIconConvert(row.deviceCatalog, row.deviceType).icon
                "
                :title="
                  equiIconConvert(row.deviceCatalog, row.deviceType).title
                "
              ></i>
            </template>
            <!-- 具体到设备 -->
            <template v-else>
              <!-- {{ row }} -->
              <i
                style="margin-right: 5px"
                :class="deviceTypeFn(row.deviceType, 'icon')"
                :title="deviceTypeFn(row.deviceType, 'title')"
              ></i>
            </template>

            <i
              style="margin-right: 5px"
              :class="equiStatusConvert(row.deviceStatus).icon"
              :title="$t(equiStatusConvert(row.deviceStatus).title)"
            ></i>

            <template v-if="routerType === 'real'">
              <span :title="row.fullPath">{{
                row.deviceName || row.tagId
              }}</span>
            </template>
            <template v-else>
              <el-tooltip class="item" effect="dark" placement="top-start">
                <span slot="content">
                  <span
                    >{{ $t('integration.belonging_to') }}：{{
                      `${row.fullPath}`
                    }}</span
                  ><br />{{ $t('integration.describe') }}：{{
                    row.deviceDescription
                  }}
                </span>
                <span>{{ row.deviceName || row.tagId }}</span>
              </el-tooltip>
            </template>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="optare" align="center" width="60px">
        <template #default="{ row }">
          <el-button
            type="text"
            icon="el-icon-tickets"
            :title="$t('integration.details')"
            @click="detailFn(row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <slot></slot>
  </div>
</template>

<script>
import {
  displayTypeConvert,
  equiIconConvert,
  equiStatusConvert,
  equiTypeConvert,
  gatewayTypeConvert,
  relayTypeConvert,
  gasTypeConvert,
  magnetismTypeConvert
} from '@/utils/convert.js'
import bus from '@/utils/bus.js'
import { sensorTypeConvert } from '@/utils/dict/sensor'

export default {
  components: {},
  props: ['loading', 'allChooze', 'tableData', 'routerType', 'deviceIcon'],
  watch: {
    tableData: {
      handler (newVal) {
        // const newArray = JSON.parse(sessionStorage.getItem('newArray')) || [];
        const newArray = this.rightArray
        this.newTable = [...newVal]
        if (this.$refs.multipleTable) {
          this.$refs.multipleTable.clearSelection()
        }
        // console.log(newArray, this.newTable);
        this.$nextTick(() => {
          this.newTable.forEach(item => {
            newArray.forEach(op => {
              if (
                op.deviceCatalog === item.deviceCatalog &&
                op.param.id === item.deviceId
              ) {
                this.$refs.multipleTable.toggleRowSelection(item, true)
              }
            })
            // if (item.isChooze) {
            //     this.$refs.multipleTable.toggleRowSelection(item, true);
            // }
          })
        })
      }
    }
  },
  data () {
    return {
      sensorTypeConvert,
      gatewayTypeConvert,
      relayTypeConvert,
      displayTypeConvert,
      equiTypeConvert,
      equiStatusConvert,
      equiIconConvert,
      tableHeight: '100%',
      newTable: [],
      rightArray: [],
      gasTypeConvert,
      magnetismTypeConvert
    }
  },
  mounted () {
    bus.$on('selectAll', bool => {
      if (bool) {
        this.$refs.multipleTable.toggleAllSelection(bool)
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    })
    bus.$on('selectListChange', arr => {
      this.rightArray = arr
      this.$emit('refreshList')
    })
    // 右侧展示内容反馈的方法 取消列表勾选
    this.cancelCkeckFn()
  },
  destroyed () {
    bus.$off('cancelCheck')
    bus.$off('selectAll')
    bus.$off('selectListChange')
  },
  methods: {
    cancelCkeckFn () {
      bus.$on('cancelCheck', id => {
        this.tableData.forEach(item => {
          if (item.deviceId === id) {
            item.isChooze = false
            this.$refs.multipleTable.toggleRowSelection(item, false)
          }
        })
        // 更改全选框的半选状态
        bus.$emit('Indeterminate', this.tableData)
      })
    },
    getGenerValueFn (array = [], obj) {
      array.forEach(item => {
        item.content = ''
        for (const newKey in obj) {
          item.key === newKey ? (item.content = obj[newKey]) : null
        }
      })
    },
    detailFn (row) {
      switch (this.deviceIcon || String(row.deviceCatalog)) {
        case '0': {
          bus.$emit('sensorParam', row.deviceId, row.deviceName)
          break
        }
        case '1': {
          bus.$emit('gatewayParam', row.deviceId, row.deviceName)
          break
        }
        case '2': {
          bus.$emit('displayParam', row.deviceId, row.deviceName)
          break
        }
        case '3': {
          bus.$emit('relayParam', row.deviceId, row.deviceName)
          break
        }
        case '5': {
          bus.$emit('gasParam', row.deviceId, row.deviceName)
          break
        }
        case '6': {
          bus.$emit('magnetismParam', row.deviceId, row.deviceName)
          break
        }
        default:
          break
      }
    },
    deviceTypeFn (type, str) {
      switch (this.deviceIcon) {
        case '0': {
          return sensorTypeConvert(type)[str]
        }
        case '1': {
          return gatewayTypeConvert(type)[str]
        }
        case '2': {
          return displayTypeConvert(type) && displayTypeConvert(type)[str]
        }
        case '3': {
          return relayTypeConvert(type)[str]
        }
       case '5': {
          return gasTypeConvert(type)[str]
        }
        case '6': {
          return magnetismTypeConvert(type)[str]
        }
        default:
          return ''
          break
      }
    },
    handleSelectRow (rows, row) {
      const isSelected = rows.length && rows.indexOf(row) !== -1 // true就是选中，0或者false是取消选中
      // 是半选还是全选
      const checkedCount = rows.length
      // 全选
      const checkAll = checkedCount === this.tableData.length
      // 半选
      const isIndeterminate =
        checkedCount > 0 && checkedCount < this.tableData.length
      bus.$emit('SelectRow', {
        checkAll,
        isIndeterminate,
        isSelected,
        row
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.deviceList {
  width: 100%;
  flex: 1;
  padding: 0 2px;
  box-sizing: border-box;
  overflow: auto;

  ::v-deep .el-table-column--selection .cell {
    padding-left: 0;
  }
}
</style>
